import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router";
import classes from "../../Challenge.module.css";
import { toast } from "react-toastify";
import AUTH_CONTEXT from "../../../../store";
import Card from "../../../../components/Card/Card";
import Button from "../../../../components/Button/Button";
import { BadgesServices } from "../../../../services/challenge_services"; // Assuming BadgesServices handles badge-related API calls
import { Breadcrumbs, Typography } from "@mui/material";
import { BASE_PATH_TO_BADGES_LIST } from "../../../../base_routes_paths/challenge_paths";

const UpdateBadge = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const [badgeName, setBadgeName] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [badgeDescription, setBadgeDescription] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [badgeAchievedImageUrl, setBadgeAchievedImageUrl] = useState("");
    const [badgeUnachievedImageUrl, setBadgeUnachievedImageUrl] = useState("");
    const [badgeCategory, setBadgeCategory] = useState("");
    const [badgeDuration, setBadgeDuration] = useState(0);
    const [badgeWorkoutID, setBadgeWorkoutID] = useState(0);
    const [cumulativeRank, setCumulativeRank] = useState(1);
    const [badgeID, setbadgeID] = useState(1);
    const [isAllWorkouts, setIsAllWorkouts] = useState(false);
    const [isRankBasedCumulative, setIsRankBasedCumulative] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [badgeCategoryName, setBadgeCategoryName] = useState("");
    const [badgeSummary, setBadgeSummary] = useState({
        "en-US": "", "en-IN": "", "en-CA": "", "hi-IN": "", "ar-AE": ""
    });
    const [IsLoaderLoading, setIsLoaderLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { token } = AUTH_CONTEXT();

    const handleInputChange = (setState) => (e) => setState(e.target.value);

    const handleDescriptionChange = (e, locale) => {
        setBadgeDescription(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const handleNameChange = (e, locale) => {
        setBadgeName(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const handleSummaryChange = (e, locale) => {
        setBadgeSummary(prevState => ({
            ...prevState,
            [locale]: e.target.value
        }));
    };

    const SubmitHandler = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const badgeData = {
            Data: {
                BadgeName: badgeName,
                BadgeDescription: badgeDescription,
                BadgeAchievedImageUrl: badgeAchievedImageUrl,
                BadgeUnachievedImageUrl: badgeUnachievedImageUrl,
                BadgeCategory: +badgeCategory,
                BadgeCategoryName: badgeCategoryName,
                BadgeWorkoutID: badgeWorkoutID,
                BadgeDuration: badgeDuration,
                IsRankBasedCumulative: isRankBasedCumulative,
                CumulativeRank: cumulativeRank,
                IsAllWorkouts: isAllWorkouts,
                IsActive: isActive,
                BadgeSummary: badgeSummary,
                BadgeID: badgeID
            },
            _id: params.ID
        };

        try {
            const response = await BadgesServices.addBadges(token, navigate, badgeData);
            setIsLoading(false);
            if (response.status === 207) {
                return toast.error(response.error, { position: "bottom-left", autoClose: 3000, hideProgressBar: true });
            }
            navigate(BASE_PATH_TO_BADGES_LIST);
            toast.success("Badge added successfully!", { position: "bottom-left", autoClose: 2000, theme: "light" });
        } catch (e) {
            setIsLoading(false);
            toast.error(e.message, { position: "bottom-left", autoClose: 5000, theme: "light" });
        }
    };

    const FetchResponse = async () => {
        try {
            let response = await BadgesServices.getAllBadge(token, navigate, params.ID);
            setIsLoaderLoading(true)
            if (response.status === 207) {
                return toast
                    .error(response.error, {
                        position: "bottom-left",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "light",
                    })
            }
            toast.success("Data Fetched successfully!!", {
                position: "bottom-left",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            return response.data;
        } catch (e) {
            setIsLoaderLoading(false);
            toast.error(e.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };

    useEffect(() => {
        const FetchData = async () => {
            try {
                const resp = await FetchResponse();
                const response = resp[0];

                if (response) {
                    setBadgeName(response.BadgeName || badgeName);
                    setBadgeDescription(response.BadgeDescription || badgeDescription);
                    setBadgeAchievedImageUrl(response.BadgeAchievedImageUrl || "");
                    setBadgeUnachievedImageUrl(response.BadgeUnachievedImageUrl || "");
                    setBadgeCategory(response.BadgeCategory || "");
                    setBadgeCategoryName(response.BadgeCategoryName || "");
                    setBadgeDuration(response.BadgeDuration || 0);
                    setBadgeWorkoutID(response.BadgeWorkoutID || 0);
                    setCumulativeRank(response.CumulativeRank || 1);
                    setbadgeID(response.BadgeID || 1);
                    setIsAllWorkouts(response.IsAllWorkouts || false);
                    setIsRankBasedCumulative(response.IsRankBasedCumulative || false);
                    setIsActive(response.IsActive || true);
                    setBadgeSummary(response.BadgeSummary || badgeSummary);
                }

                toast.success("Data fetched successfully!", {
                    position: "bottom-left",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                setIsLoaderLoading(false);
            } catch (error) {
                setIsLoaderLoading(false);
                toast.error(error.message, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        };

        if (params.ID) {
            FetchData();
        }
    }, []);

    return (
        <div className={classes.crumbs}>
            <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/dashboard">Dashboard</Link>
                <Typography color="text.primary">Badges</Typography>
                <Typography color="text.primary">Create Badge</Typography>
            </Breadcrumbs>
            <Card className={classes.input}>
                <form onSubmit={SubmitHandler}>
                    <div className={classes.subfields}>
                        <h3>Badge Name Translations</h3>
                        {Object.keys(badgeName).map(locale => (
                            <div key={locale} className={classes.control}>
                                <label>{`Name (${locale})`}</label>
                                <input type="text" value={badgeName[locale]} onChange={e => handleNameChange(e, locale)} placeholder={`Enter name for ${locale}`} />
                            </div>
                        ))}
                    </div>
                    <div className={classes.subfields}>
                        <h3>Badge Description Translations</h3>
                        {Object.keys(badgeDescription).map(locale => (
                            <div key={locale} className={classes.control}>
                                <label>{`Description (${locale})`}</label>
                                <input type="text" value={badgeDescription[locale]} onChange={e => handleDescriptionChange(e, locale)} placeholder={`Enter description for ${locale}`} />
                            </div>
                        ))}
                    </div>
                    <div className={classes.control}>
                        <label>Badge Achieved Image URL:</label>
                        <input type="url" required value={badgeAchievedImageUrl} onChange={handleInputChange(setBadgeAchievedImageUrl)} placeholder="Enter achieved image URL" />
                    </div>
                    <div className={classes.control}>
                        <label>Badge Unachieved Image URL:</label>
                        <input type="url" required value={badgeUnachievedImageUrl} onChange={handleInputChange(setBadgeUnachievedImageUrl)} placeholder="Enter unachieved image URL" />
                    </div>
                    <div className={classes.control}>
                        <label htmlFor="badgeID">Badge ID:</label>
                        <input
                            type="number"
                            id="badgeID"
                            required
                            value={badgeID}
                            onChange={(e) => setbadgeID(parseInt(e.target.value))}
                            placeholder="Enter Badge ID"
                        />
                    </div>

                    <div className={classes.control}>
                        <label htmlFor="badgeDuration">Badge Duration (in days):</label>
                        <input
                            type="number"
                            id="badgeDuration"
                            required
                            value={badgeDuration}
                            onChange={(e) => setBadgeDuration(parseInt(e.target.value))}
                            placeholder="Enter Badge Duration"
                        />
                    </div>

                    <div className={classes.control}>
                        <label htmlFor="badgeWorkoutID">Badge Workout ID:</label>
                        <input
                            type="number"
                            id="badgeWorkoutID"
                            required
                            value={badgeWorkoutID}
                            onChange={(e) => setBadgeWorkoutID(parseInt(e.target.value))}
                            placeholder="Enter Workout ID for Badge"
                        />
                    </div>

                    <div className={classes.control}>
                        <label htmlFor="cumulativeRank">Cumulative Rank:</label>
                        <input
                            type="number"
                            id="cumulativeRank"
                            required
                            value={cumulativeRank}
                            onChange={(e) => setCumulativeRank(parseInt(e.target.value))}
                            placeholder="Enter Cumulative Rank"
                        />
                    </div>
                    <div className={classes.control}>
                        <label>Badge Category:</label>
                        <input type="text" required value={badgeCategory} onChange={handleInputChange(setBadgeCategory)} placeholder="Enter category" />
                    </div>
                    <div className={classes.control}>
                        <label>Badge Category Name:</label>
                        <input type="text" value={badgeCategoryName} onChange={handleInputChange(setBadgeCategoryName)} placeholder="Enter category name" />
                    </div>

                    <div className={classes.selectbox} >
                        <label htmlFor="isRankBasedCumulative">isRankBasedCumulative : </label>
                        <select
                            name="isRankBasedCumulative"
                            id="isRankBasedCumulative"
                            value={isRankBasedCumulative}
                            onChange={(e) => setIsRankBasedCumulative(e.target.value)}
                        >
                            <option value={false}>False</option>
                            <option value={true}>True</option>
                        </select>
                    </div>

                    <div className={classes.selectbox} >
                        <label htmlFor="isAllWorkouts">isAllWorkouts : </label>
                        <select
                            name="isAllWorkouts"
                            id="isAllWorkouts"
                            value={isAllWorkouts}
                            onChange={(e) => setIsAllWorkouts(e.target.value)}
                        >
                            <option value={false}>False</option>
                            <option value={true}>True</option>
                        </select>
                    </div>

                    <div className={classes.selectbox} >
                        <label htmlFor="IsActive">IsActive : </label>
                        <select
                            name="IsActive"
                            id="IsActive"
                            value={isActive}
                            onChange={(e) => setIsActive(e.target.value)}
                        >
                            <option value={false}>False</option>
                            <option value={true}>True</option>
                        </select>
                    </div>

                    <div className={classes.subfields}>
                        <h3>Badge Summary Translations</h3>
                        {Object.keys(badgeSummary).map(locale => (
                            <div key={locale} className={classes.control}>
                                <label>{`Summary (${locale})`}</label>
                                <input type="text" value={badgeSummary[locale]} onChange={e => handleSummaryChange(e, locale)} placeholder={`Enter summary for ${locale}`} />
                            </div>
                        ))}
                    </div>
                    {!isLoading && <Button type="submit">Update Badge</Button>}
                    {isLoading && <p>Sending request...</p>}
                </form>
            </Card>
        </div>
    );
};

export default UpdateBadge;
